import { SYSTEM_FIELD_DATA, SYSTEM_FIELDS } from './SystemFieldConstants';
import constants, { DATA_TYPES } from './CommonConstants';

const { CHURN_DATE, CHURN_REASON, EMAIL, LIFECYCLE_STAGE, OWNER, EXTERNAL_ID } =
  SYSTEM_FIELDS;
const { ACCOUNT_LEVEL, ORGANIZATION_LEVEL, CONTACT_LEVEL, PIPELINE_LEVEL } =
  constants;

const ABOUT_FIELD_DATA = {
  systemFieldId: -16,
  name: 'system:about',
  displayName: 'About',
  dataType: DATA_TYPES.longText,
};

export const CHANGELOG_SYSTEM_FIELDS = {
  PRIMARY_OWNER: 'owner 1',
  SECONDARY_OWNER: 'owner 2',
  LIFECYCLE_STAGE: 'lifecycle stage',
  CHURN_DATE: 'churn date',
  CHURN_REASON: 'churn reason',
  EMAIL: 'email',
  EXTERNAL_ID: 'external id',
  ABOUT: 'about',
};

export const SYSTEM_FIELDS_DISPLAY_NAME_MAPPING = {
  [CHANGELOG_SYSTEM_FIELDS.PRIMARY_OWNER]: 'Primary Owner',
  [CHANGELOG_SYSTEM_FIELDS.SECONDARY_OWNER]: 'Secondary Owner',
  [CHANGELOG_SYSTEM_FIELDS.LIFECYCLE_STAGE]: 'Lifecycle Stage',
  [CHANGELOG_SYSTEM_FIELDS.CHURN_DATE]: 'Churn Date',
  [CHANGELOG_SYSTEM_FIELDS.CHURN_REASON]: 'Churn Reason',
  [CHANGELOG_SYSTEM_FIELDS.EMAIL]: 'Email',
  [CHANGELOG_SYSTEM_FIELDS.EXTERNAL_ID]: 'External Id',
  [CHANGELOG_SYSTEM_FIELDS.ABOUT]: 'About',
};

export const LEVEL_SYSTEM_FIELDS_DATA_MAPPING = {
  [ACCOUNT_LEVEL]: [
    SYSTEM_FIELD_DATA[CHURN_DATE],
    SYSTEM_FIELD_DATA[CHURN_REASON],
    SYSTEM_FIELD_DATA[LIFECYCLE_STAGE],
    SYSTEM_FIELD_DATA[OWNER],
    SYSTEM_FIELD_DATA[EXTERNAL_ID],
    ABOUT_FIELD_DATA,
  ],
  [ORGANIZATION_LEVEL]: [
    SYSTEM_FIELD_DATA[CHURN_DATE],
    SYSTEM_FIELD_DATA[CHURN_REASON],
    SYSTEM_FIELD_DATA[LIFECYCLE_STAGE],
    SYSTEM_FIELD_DATA[OWNER],
    SYSTEM_FIELD_DATA[EXTERNAL_ID],
    ABOUT_FIELD_DATA,
  ],
  [CONTACT_LEVEL]: [
    SYSTEM_FIELD_DATA[EMAIL],
    SYSTEM_FIELD_DATA[LIFECYCLE_STAGE],
    SYSTEM_FIELD_DATA[EXTERNAL_ID],
    ABOUT_FIELD_DATA,
  ],
  [PIPELINE_LEVEL]: [],
};

export const ENTITY_CHANGE_LOG_PAGE_SIZE = 50;
